/* funnls - cart upgrades: an UpCart upsell that is an upgrade replaces the
   item it upgrades. Idempotent.

   Why this exists (Ben, 2026-09-28): Kim's cart offers are mostly upgrades -
   Aura to a set, a Bloom to the Gliding Trio, a Bare to the Fresh Pack, A
   Moment Set to the Complete Set. UpCart's upsells only ever add a line, so
   accepting one would charge the customer for the original item and the set.
   When UpCart reports an upsell was added, this takes one unit of the item it
   upgrades out of the cart.

   Only upsell adds count. A line UpCart adds carries the hidden property
   __upcartUpsell, and UpCart fires "upsell added" for it; an item the
   customer puts in the cart themselves is never touched, so someone buying
   Aura and a Complete Set as a gift keeps both.

   A subscription carries over: if the item being replaced is on a
   subscription, the upgrade is added on the upgrade's first subscription plan
   too (Bare on subscription becomes Fresh Pack on subscription).

   Rules match what is in the cart by product id (the new sets' ids were read
   from the UpCart draft on 2026-10-01, while the products were still drafts).
   The first rule whose "upgrade" matches wins; its "replaces" list is tried in
   order and one unit of the first line found is removed. */
(function () {
  if (window.__funnlsCartUpgrades) return;
  window.__funnlsCartUpgrades = true;

  // The Aura price test (Intelligems, 2026-10-06) shows test-group shoppers
  // copies of Aura and of every set containing it, with their own product
  // ids. Each list below carries the original first, then its copy, so an
  // upgrade swaps in both groups. Copy ids from Intelligems' support team.
  var AURA = [8012410781785, 9525974302809];
  var MOMENT_SET = [
    8034535964761, 9531446788185, // aura-wild-peony + copy
    8034536489049, 9531446755417, // aura-honeydew-melon + copy
    8034536849497, 9531446886489, // aura-fragrance-free + copy
  ];
  var BLOOM = [8012408127577, 8012408946777, 8012409077849]; // wild peony, honeydew melon, fragrance free
  var BARE = 8012409208921;
  var BARE_CART_ONLY = 8283837366361; // vanilla-30-count-cart
  var GLIDING_TRIO = 8034136490073;
  var COMPLETE_SET = [
    9519092432985, 9531446820953, // complete-set-wild-peony + copy
    9519093088345, 9531446984793, // complete-set-honeydew-melon + copy
    9519098527833, 9531447017561, // complete-set-fragrance-free + copy
  ];
  var FRESH_PACK = 9519120318553;
  var PLEASURE_BACK_SET = [
    9524477132889, 9531446919257, // pleasure-back-set-wild-peony + copy
    9524478541913, 9531447050329, // pleasure-back-set-honeydew-melon + copy
    9524462583897, 9531446952025, // pleasure-back-set-fragrance-free + copy
  ];

  function byId(ids) { ids = [].concat(ids); return function (line) { return ids.indexOf(line.product_id) > -1; }; }

  var RULES = [
    { name: 'Complete Set', upgrade: byId(COMPLETE_SET), replaces: [byId(PLEASURE_BACK_SET), byId(MOMENT_SET), byId(AURA)] },
    { name: 'Pleasure Back Set', upgrade: byId(PLEASURE_BACK_SET), replaces: [byId(MOMENT_SET), byId(AURA)] },
    { name: 'A Moment Set', upgrade: byId(MOMENT_SET), replaces: [byId(AURA)] },
    { name: 'Gliding Trio', upgrade: byId(GLIDING_TRIO), replaces: [byId(BLOOM)] },
    { name: 'Fresh Pack', upgrade: byId(FRESH_PACK), replaces: [byId(BARE), byId(BARE_CART_ONLY)] },
  ];

  var UPSELL_PROP = '__upcartUpsell';
  var lastCart = null;
  var handled = {};

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function isUpsellLine(line) {
    return !!(line.properties && line.properties[UPSELL_PROP]);
  }

  function ruleFor(line) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].upgrade(line)) return RULES[i];
    return null;
  }

  // The line an upgrade would replace, skipping the upgrade line itself.
  function targetFor(rule, cart, upgradeLine) {
    for (var i = 0; i < rule.replaces.length; i++) {
      for (var j = 0; j < cart.items.length; j++) {
        var line = cart.items[j];
        if (line === upgradeLine || line.key === (upgradeLine && upgradeLine.key)) continue;
        if (rule.replaces[i](line)) return line;
      }
    }
    return null;
  }

  function refresh() {
    try { if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart(); } catch (e) {}
  }

  // Called with the variant id UpCart just added as an upsell.
  function handleUpsellAdded(variantId) {
    variantId = +String(variantId).replace(/\D/g, ''); // UpCart may pass a gid
    return getCart().then(function (cart) {
      lastCart = cart;
      var added = null;
      for (var i = cart.items.length - 1; i >= 0; i--) {
        var line = cart.items[i];
        if (line.variant_id === variantId && isUpsellLine(line)) { added = line; break; }
      }
      if (!added) return null;
      var tag = added.key + ':' + added.quantity;
      // UpCart can report one add twice; the same line again later (removed
      // and accepted again) is a new upgrade and swaps again.
      if (handled[tag] && Date.now() - handled[tag] < 5000) return null;
      handled[tag] = Date.now();
      var rule = ruleFor(added);
      if (!rule) return null;
      var target = targetFor(rule, cart, added);
      if (!target) return null;
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: target.key, quantity: Math.max(target.quantity - 1, 0) }),
      })
        .then(function (r) { return r.json(); })
        .then(function (next) {
          lastCart = next;
          refresh();
          document.dispatchEvent(new CustomEvent('funnls:cart-upgraded', { detail: { upgrade: rule.name, replaced: target.handle } }));
          return { upgrade: rule.name, replaced: target.handle };
        });
    });
  }

  // Before UpCart adds an upsell: if what it upgrades is on a subscription,
  // add the upgrade on its first subscription plan as well.
  var previousSelectPlan = window.upcartSelectUpsellItemSellingPlan;
  function selectPlan(args) {
    var fallback;
    try { fallback = typeof previousSelectPlan === 'function' ? previousSelectPlan(args) : undefined; } catch (e) {}
    try {
      if (!args || !args.product || !lastCart || !args.firstSellingPlanIdForVariant) return fallback;
      var probe = { product_id: +String(args.product.id).replace(/\D/g, ''), handle: args.product.handle };
      var rule = ruleFor(probe);
      if (!rule) return fallback;
      var target = targetFor(rule, lastCart, null);
      if (target && target.selling_plan_allocation) return args.firstSellingPlanIdForVariant;
    } catch (e) {}
    return fallback;
  }
  window.upcartSelectUpsellItemSellingPlan = selectPlan;

  function hook() {
    if (typeof window.upcartSubscribeUpsellsAddedToCart !== 'function') return false;
    // If UpCart set its own plan picker while loading, wrap that one instead.
    if (window.upcartSelectUpsellItemSellingPlan !== selectPlan) {
      previousSelectPlan = window.upcartSelectUpsellItemSellingPlan;
      window.upcartSelectUpsellItemSellingPlan = selectPlan;
    }
    window.upcartSubscribeUpsellsAddedToCart(function (detail) {
      if (detail && detail.variant && detail.variant.id) handleUpsellAdded(detail.variant.id);
    });
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      // Re-read /cart.js rather than trusting UpCart's reshaped cart object.
      window.upcartSubscribeCartUpdated(function () { getCart().then(function (c) { lastCart = c; }).catch(function () {}); });
    }
    return true;
  }

  getCart().then(function (c) { lastCart = c; }).catch(function () {});
  // Wait for UpCart however long it takes (2026-10-05: on a slow phone its
  // hooks arrive 6-26s after this script; the old 10s cap meant the swap
  // never attached). Every 250ms for 15s, then every second.
  if (!hook()) {
    var tries = 0;
    (function wait() {
      if (hook()) return;
      setTimeout(wait, ++tries < 60 ? 250 : 1000);
    })();
  }

  // For testing on a preview theme: window.funnlsCartUpgrades.handle(variantId)
  window.funnlsCartUpgrades = { handle: handleUpsellAdded, rules: RULES };
})();
